export const transactionReason = {
  CASHBACK: 'cashback',
  ENGAGE_CASHBACK: 'engage_cashback',
  REFUNDED: 'refunded',
  REDEEMED: 'redeemed',
  COMPENSATION: 'compensation',
  CANCELED_CASHBACK: 'canceled_cashback',
  CANCELED_ENGAGE_CASHBACK: 'canceled_engage_cashback',
};

export const transactionOperation = {
  DEPOSIT: 'deposit',
  WITHDRAW: 'withdraw',
};
